import { initializeApp } from 'firebase/app';
import { browserLocalPersistence,initializeAuth,indexedDBLocalPersistence,browserPopupRedirectResolver } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = initializeAuth(app, {
    persistence: [
      browserLocalPersistence,
      indexedDBLocalPersistence,
    ],
    popupRedirectResolver: browserPopupRedirectResolver,
  });

// Set persistence to LOCAL
// This will maintain the user's authentication state even after browser restart
// setPersistence(auth, browserLocalPersistence)
//     .then(() => {
//         console.log('Firebase - Persistence set to LOCAL');
//     })
//     .catch((error) => {
//         console.error('Firebase - Error setting persistence:', error);
//     });

const db = getFirestore(app);
const storage = getStorage(app);

// Enable testing mode for local development
if (window.location.hostname === 'localhost') {
    auth.useDeviceLanguage();
    auth.settings.appVerificationDisabledForTesting = true;
}

export { auth, db, storage };
